const Icons = {
    tick: '✔',
    close: '❌',
    thumbsDown: '👎',
    thumbsUp: '👍',
};

export default Icons;
